const Breadcrumb = ({ title }) => {
  return null;
};

export default Breadcrumb;
